module.exports = __webpack_public_path__ + "img/bottom.0a81d8de.png";